interface CategorySelectProps {
  value: string;
  onChange: (next: string) => void;
  suggestions: string[];
}

// Editable text input + datalist of existing categories. Lets the admin pick
// an existing category or type a brand new one — same UX as a "creatable
// select" without an extra dependency.
export function CategorySelect({ value, onChange, suggestions }: CategorySelectProps) {
  return (
    <>
      <input
        className="input"
        list="category-suggestions"
        value={value}
        placeholder="e.g. Paintings, Sketches, Sculpture"
        onChange={(e) => onChange(e.target.value)}
        required
      />
      <datalist id="category-suggestions">
        {suggestions.map((s) => (
          <option key={s} value={s} />
        ))}
      </datalist>
    </>
  );
}
